import script from "./sub1Option.vue?vue&type=script&setup=true&lang=js"
export * from "./sub1Option.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__